import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Play, Film, Wrench, Building2, Instagram, Shield, MessageCircle, ExternalLink } from 'lucide-react';

const VideoPage = () => {
  const { language } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');

  const content = {
    ru: {
      header: {
        title: 'Видео',
        subtitle: 'Смотрите наши видеообзоры и реальные проекты'
      },
      categories: {
        all: 'Все видео',
        reviews: 'Обзоры продукции',
        installation: 'Монтаж',
        projects: 'Наши объекты',
        crashtests: 'Краш-тесты',
        testimonials: 'Отзывы клиентов'
      }
    },
    kz: {
      header: {
        title: 'Бейне',
        subtitle: 'Біздің бейне шолуларымызды және нақты жобаларды қараңыз'
      },
      categories: {
        all: 'Барлық бейнелер',
        reviews: 'Өнім шолулары',
        installation: 'Монтаж',
        projects: 'Біздің объектілер',
        crashtests: 'Краш-тесттер',
        testimonials: 'Клиент пікірлері'
      }
    },
    en: {
      header: {
        title: 'Videos',
        subtitle: 'Watch our video reviews and real projects'
      },
      categories: {
        all: 'All Videos',
        reviews: 'Product Reviews',
        installation: 'Installation',
        projects: 'Our Projects',
        crashtests: 'Crash Tests',
        testimonials: 'Customer Reviews'
      }
    },
    ar: {
      header: {
        title: 'الفيديوهات',
        subtitle: 'شاهد مراجعاتنا المرئية والمشاريع الفعلية'
      },
      categories: {
        all: 'جميع الفيديوهات',
        reviews: 'مراجعات المنتجات',
        installation: 'التركيب',
        projects: 'مشاريعنا',
        crashtests: 'اختبارات التحمّل',
        testimonials: 'تقييمات العملاء'
      }
    }
  };

  // Видео с названиями и категориями
  const videos = [
    {
      id: 1,
      category: 'reviews',
      reelId: 'DV-sk1SgCBP',
      thumbnail: '/images/video/thumb_1.jpg',
      title: {
        ru: 'Перегородки из панелей',
        kz: 'Панельдерден жасалған бөлгіштер',
        en: 'Panel partitions', ar: 'الحواجز اللوحية'
      }
    },
    {
      id: 2,
      category: 'reviews',
      reelId: 'DSHkFZdCK3H',
      thumbnail: '/images/video/thumb_2.jpg',
      title: {
        ru: 'Дизайн решения для офиса',
        kz: 'Кеңсеге арналған дизайн шешімдері',
        en: 'Design solutions for office', ar: 'حلول تصميمية للمكاتب'
      }
    },
    {
      id: 3,
      category: 'crashtests',
      reelId: 'DUmu7c5gTLs',
      thumbnail: '/images/video/thumb_bamboo_compare.jpg',
      title: {
        ru: 'Сравнение с бамбуковыми панелями',
        kz: 'Бамбук панельдерімен салыстыру',
        en: 'Comparison with bamboo panels', ar: 'مقارنة مع الألواح الخيزرانية'
      }
    },
    {
      id: 4,
      category: 'reviews',
      reelId: 'DG0dG4XiGs2',
      thumbnail: '/images/video/thumb_launch.jpg',
      title: {
        ru: 'Запуск производства ТОО Гипсовинил',
        kz: 'Гипсовинил ЖШС өндірісін іске қосу',
        en: 'GIPSOVINIL production launch', ar: 'إطلاق إنتاج GIPSOVINIL.KZ'
      }
    },
    {
      id: 5,
      category: 'projects',
      reelId: 'DPVxkZ0iDhZ',
      thumbnail: '/images/video/thumb_projects.jpg',
      title: {
        ru: 'Реализованные проекты с панелями',
        kz: 'Панельдермен жүзеге асырылған жобалар',
        en: 'Completed projects with panels', ar: 'المشاريع المنجزة بالألواح'
      }
    },
    {
      id: 6,
      category: 'projects',
      reelId: 'DSpYwrliL7a',
      thumbnail: '/images/video/thumb_camp.jpg',
      title: {
        ru: 'Вахтовый городок',
        kz: 'Вахталық қалашық',
        en: 'Rotational camp', ar: 'مخيم العمل الدوري'
      }
    },
    {
      id: 7,
      category: 'projects',
      reelId: 'DRhMb84CO77',
      thumbnail: '/images/video/thumb_school.jpg',
      title: {
        ru: 'Школьные помещения',
        kz: 'Мектеп бөлмелері',
        en: 'School premises', ar: 'مرافق المدرسة'
      }
    },
    {
      id: 8,
      category: 'projects',
      reelId: 'DS-HysFCPnu',
      thumbnail: '/images/video/thumb_tax.jpg',
      title: {
        ru: 'Налоговая в г. Павлодар',
        kz: 'Павлодар қ. салық басқармасы',
        en: 'Tax office in Pavlodar', ar: 'مصلحة الضرائب في بافلودار'
      }
    },
    {
      id: 9,
      category: 'projects',
      reelId: 'DRy2UALCBGW',
      thumbnail: '/images/video/thumb_atyrau.jpg',
      title: {
        ru: 'Реконструкция Атырау Акпарат',
        kz: 'Атырау Ақпарат қайта құру',
        en: 'Atyrau Akparat reconstruction', ar: 'إعادة إعمار Atyrau Akparat'
      }
    },
    {
      id: 10,
      category: 'reviews',
      reelId: 'DQB-W5eCIQZ',
      thumbnail: '/images/video/thumb_pool.jpg',
      title: {
        ru: 'Панели Комфорт в бассейнах',
        kz: 'Бассейндердегі Комфорт панельдері',
        en: 'Comfort panels in swimming pools', ar: 'ألواح Comfort في المسابح'
      }
    },
    {
      id: 11,
      category: 'reviews',
      reelId: 'DQlaKRUCC_g',
      thumbnail: '/images/video/thumb_stylish_office.jpg',
      title: {
        ru: 'Стильный офис из панелей',
        kz: 'Панельдерден стильді кеңсе',
        en: 'Stylish office from panels', ar: 'مكتب أنيق بالألواح'
      }
    },
    {
      id: 12,
      category: 'reviews',
      reelId: 'C91K2Rot5xk',
      thumbnail: '/images/video/thumb_medical.jpg',
      title: {
        ru: 'Панели в медучреждениях',
        kz: 'Медициналық мекемелердегі панельдер',
        en: 'Panels in medical facilities', ar: 'ألواح في المنشآت الطبية'
      }
    },
    {
      id: 13,
      category: 'projects',
      reelId: 'DA57FzytlUL',
      thumbnail: '/images/video/thumb_panels_jk.jpg',
      title: {
        ru: 'Панели в ЖК от Bazis-A',
        kz: 'Bazis-A ТК-дегі панельдер',
        en: 'Panels in Bazis-A residential complex', ar: 'ألواح في مجمع Bazis-A السكني'
      }
    },
    {
      id: 14,
      category: 'installation',
      reelId: 'DApnj-Yta7Z',
      thumbnail: '/images/video/thumb_montage_process.jpg',
      title: {
        ru: 'Процесс монтажа',
        kz: 'Орнату процесі',
        en: 'Installation process', ar: 'عملية التركيب'
      }
    },
    {
      id: 15,
      category: 'installation',
      reelId: 'DC4IYWEvAKx',
      thumbnail: '/images/video/thumb_montage_site.jpg',
      title: {
        ru: 'Монтаж на объекте',
        kz: 'Нысанда орнату',
        en: 'On-site installation', ar: 'التركيب في الموقع'
      }
    },
    {
      id: 16,
      category: 'reviews',
      reelId: 'DV2ka1MEfGl',
      thumbnail: '/images/video/thumb_nomad.jpg',
      title: {
        ru: 'Обзор Nomad Panels',
        kz: 'Nomad Panels шолуы',
        en: 'Nomad Panels overview', ar: 'نظرة عامة على ألواح Nomad'
      }
    },
    {
      id: 17,
      category: 'reviews',
      reelId: 'DVipogvD1Dn',
      thumbnail: '/images/video/thumb_ornaments.jpg',
      title: {
        ru: 'Панели с национальными орнаментами',
        kz: 'Ұлттық ою-өрнектері бар панельдер',
        en: 'Panels with national ornaments', ar: 'ألواح بزخارف وطنية'
      }
    },
    {
      id: 18,
      category: 'reviews',
      reelId: 'DANgLPVNvXN',
      thumbnail: '/images/video/thumb_review_gv.webp',
      title: {
        ru: 'Обзор на Гипсовинил',
        kz: 'Гипсовинилге шолу',
        en: 'Gipsovinil review', ar: 'تقييم GIPSOVINIL.KZ'
      }
    },
    {
      id: 19,
      category: 'reviews',
      reelId: 'DAVjdnWteSp',
      thumbnail: '/images/video/thumb_composition.jpg',
      title: {
        ru: 'Состав гипсовиниловых панелей',
        kz: 'Гипсовинил панельдерінің құрамы',
        en: 'Gypsum vinyl panel composition', ar: 'تركيبة لوح الجبس الفينيل'
      }
    },
    {
      id: 20,
      category: 'testimonials',
      reelId: 'DSr1HrRCM4g',
      thumbnail: '/images/video/thumb_kids_center.jpg',
      title: {
        ru: 'Детский центр в панелях',
        kz: 'Панельдердегі балалар орталығы',
        en: 'Children\'s center with panels', ar: 'مركز الأطفال بالألواح'
      }
    },
    {
      id: 21,
      category: 'testimonials',
      reelId: 'DHH8JCsCMad',
      thumbnail: '/images/video/thumb_review_customer.jpg',
      title: {
        ru: 'Отзыв заказчика',
        kz: 'Тапсырыс берушінің пікірі',
        en: 'Customer review', ar: 'تقييم العميل'
      }
    },
    {
      id: 22,
      category: 'testimonials',
      reelId: 'DA3XIoGNa5j',
      thumbnail: '/images/video/thumb_hospital_review.webp',
      title: {
        ru: 'Отзыв застройщика больницы',
        kz: 'Аурухана құрылысшысының пікірі',
        en: 'Hospital developer review', ar: 'تقييم مطوّر من قطاع المستشفيات'
      }
    },
    {
      id: 23,
      category: 'testimonials',
      reelId: 'C8Y9EocoIM8',
      thumbnail: '/images/video/thumb_hospital_client2.jpg',
      title: {
        ru: 'Отзыв Заказчика больницы',
        kz: 'Аурухана тапсырыс берушісінің пікірі',
        en: 'Hospital client review', ar: 'تقييم عميل من قطاع المستشفيات'
      }
    },
    {
      id: 24,
      category: 'testimonials',
      reelId: 'C8BhHXYN7YE',
      thumbnail: '/images/video/thumb_recommendation.webp',
      title: {
        ru: 'Рекомендация клиента',
        kz: 'Клиенттің ұсынысы',
        en: 'Client recommendation', ar: 'توصية العميل'
      }
    },
    {
      id: 25,
      category: 'projects',
      reelId: 'DPoMR9YiIKY',
      thumbnail: '/images/video/thumb_school_comfort.jpg',
      title: {
        ru: 'Обзор Комфортной школы',
        kz: 'Жайлы мектепке шолу',
        en: 'Comfortable school overview', ar: 'نظرة عامة على مدرسة مريحة'
      }
    },
    {
      id: 26,
      category: 'projects',
      reelId: 'DNngz8kNmmX',
      thumbnail: '/images/video/thumb_abk_aktau.jpg',
      title: {
        ru: 'АБК в Актау',
        kz: 'Ақтаудағы ӘБК',
        en: 'Administrative building in Aktau', ar: 'مبنى إداري في أكتاو'
      }
    },
    {
      id: 27,
      category: 'projects',
      reelId: 'DH-0tuBicwW',
      thumbnail: '/images/video/thumb_object_review.jpg',
      title: {
        ru: 'Обзор объекта',
        kz: 'Нысанға шолу',
        en: 'Object review', ar: 'مراجعة المشروع'
      }
    },
    {
      id: 28,
      category: 'crashtests',
      reelId: 'C8efrq-tmWu',
      thumbnail: '/images/video/thumb_crash_test.jpg',
      title: {
        ru: 'Краш-тест панелей',
        kz: 'Панельдердің краш-тесті',
        en: 'Panel crash test', ar: 'اختبار تحمّل الألواح'
      }
    },
    {
      id: 29,
      category: 'reviews',
      reelId: 'DDCWpeqT1X2',
      thumbnail: '/images/video/thumb_bazis_a.webp',
      title: {
        ru: 'Применение панелей в ЖК',
        kz: 'ТК-да панельдерді қолдану',
        en: 'Panel application in residential complex', ar: 'تركيب الألواح في مجمع سكني'
      }
    }
  ];

  const t = content[language] || content.en || content.ru;

  const categoryIcons = {
    all: Film,
    reviews: Play,
    installation: Wrench,
    projects: Building2,
    crashtests: Shield,
    testimonials: MessageCircle
  };

  const [playingVideo, setPlayingVideo] = useState(null);

  const filteredVideos = activeCategory === 'all' 
    ? videos 
    : videos.filter(v => v.category === activeCategory);

  return (
    <div className="pt-20 bg-[#061d36]" data-testid="video-page">
      {/* Header */}
      <section className="py-8 bg-[#061d36] text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="video-title">{t.header.title}</h1>
          <p className="text-lg text-blue-200 max-w-3xl mx-auto">{t.header.subtitle}</p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-[#F5F5F0]">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-3">
            {Object.entries(t.categories).map(([key, label]) => {
              const IconComponent = categoryIcons[key];
              return (
                <button
                  key={key}
                  onClick={() => setActiveCategory(key)}
                  data-testid={`video-category-${key}`}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all ${
                    activeCategory === key
                      ? 'bg-[#061d36] text-white shadow-lg'
                      : 'bg-white text-[#061d36] hover:bg-gray-100'
                  }`}
                >
                  <IconComponent className="w-5 h-5" />
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Videos Grid */}
      <section className="py-12 bg-[#F5F5F0]">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
            {filteredVideos.map((video) => (
              <div
                key={video.id}
                data-testid={`video-card-${video.id}`}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group"
              >
                {/* Title above video */}
                <div className="p-3 pb-2">
                  <h3 className="font-semibold text-[#061d36] text-sm line-clamp-2">{video.title[language]}</h3>
                </div>
                {/* Video Preview / Player */}
                <div className="aspect-square bg-[#061d36] relative overflow-hidden">
                  {playingVideo === video.id ? (
                    <iframe
                      src={`https://www.instagram.com/reel/${video.reelId}/embed/`}
                      className="w-full h-full"
                      frameBorder="0"
                      scrolling="no"
                      allowFullScreen
                      title={video.title[language]}
                    />
                  ) : (
                    <div 
                      className="w-full h-full cursor-pointer relative group"
                      onClick={() => setPlayingVideo(video.id)}
                    >
                      <img 
                        src={video.thumbnail}
                        alt={video.title[language]}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                      {/* Play Button */}
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center group-hover:bg-white group-hover:scale-110 transition-all shadow-lg">
                          <div className="w-0 h-0 border-t-[10px] border-t-transparent border-l-[18px] border-l-[#061d36] border-b-[10px] border-b-transparent ml-1" />
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Category Badge Overlay */}
                  <div className="absolute bottom-3 left-3 pointer-events-none">
                    <div className="bg-[#061d36] text-white text-xs font-medium px-3 py-1 rounded shadow-lg">
                      {t.categories[video.category]}
                    </div>
                  </div>
                </div>
                
                {/* Bottom info bar */}
                <div className="p-3 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Instagram className="w-4 h-4 text-pink-500" />
                    <span className="text-xs text-gray-500">@gipsovinil.kz</span>
                  </div>
                  <a
                    href={`https://www.instagram.com/reel/${video.reelId}/`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-[#061d36] hover:text-blue-600 font-medium flex items-center gap-1"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ExternalLink className="w-3 h-3" />
                    Instagram
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram CTA */}
      <section className="py-8 bg-gradient-to-r from-purple-600 to-pink-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {language === 'ru' ? 'Подписывайтесь на наш Instagram' : 
             language === 'kz' ? 'Біздің Instagram-ға жазылыңыз' : 
             'Follow us on Instagram'}
          </h2>
          <p className="text-white/80 mb-8 max-w-2xl mx-auto">
            {language === 'ru' ? 'Больше видео, обзоров и вдохновения для ваших проектов' : 
             language === 'kz' ? 'Жобаларыңыз үшін көбірек бейне, шолу және шабыт' : 
             'More videos, reviews and inspiration for your projects'}
          </p>
          <a
            href="https://instagram.com/gipsovinil.kz"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#061d36] hover:bg-[#0d2a47] text-white rounded-xl font-bold transition-colors"
            data-testid="instagram-follow-btn"
          >
            <Instagram className="w-6 h-6" />
            @gipsovinil.kz
          </a>
        </div>
      </section>
    </div>
  );
};

export default VideoPage;
